import type { NavItem, NavItems, PagePermissions } from '@unifyapps/defs/types/interface';
import { InterfaceModes } from '../../stores/InterfaceStore/types';
import type { UserPermissionsMap } from '../types';
import { hasAccess } from './hasAccess';

function isNavItemAccessible({
  item,
  pagePermissions,
  currentPermissions,
}: {
  item: NavItem;
  pagePermissions: PagePermissions | undefined;
  currentPermissions: UserPermissionsMap;
}): boolean {
  const hasAccessOfNavItem = hasAccess(currentPermissions, item.permissions, InterfaceModes.RUNNER);

  if (item.type === 'PAGE') {
    return (
      hasAccessOfNavItem &&
      hasAccess(currentPermissions, pagePermissions?.[item.pageId], InterfaceModes.RUNNER)
    );
  }

  if (item.type === 'USER_MENU') {
    return Boolean(currentPermissions.navigation?.USER_MENU);
  }

  return hasAccessOfNavItem;
}

export function filterPermissibleNavItems({
  items,
  permissions,
  pagePermissions,
}: {
  items: NavItems;
  permissions: UserPermissionsMap;
  pagePermissions: PagePermissions | undefined;
}): NavItems {
  return items.reduce<NavItems>((acc, item) => {
    if (
      isNavItemAccessible({
        currentPermissions: permissions,
        item,
        pagePermissions,
      })
    ) {
      if (item.type === 'GROUP') {
        const filteredItems = item.items.filter((it) =>
          isNavItemAccessible({ currentPermissions: permissions, item: it, pagePermissions }),
        );

        if (filteredItems.length) {
          acc.push({
            ...item,
            items: filteredItems,
          });
        }
      } else {
        acc.push(item);
      }
    }

    return acc;
  }, []);
}
